var map = {
	"./2025 Volunteer Form.pdf": "354e",
	"./CanadaDay2019Flyer.pdf": "c1be",
	"./CanadaDay2019Sponsorship.pdf": "dd1e",
	"./CanadaDay2020Sponsorship.pdf": "8e52",
	"./CanadaDay2023Flyer.jpg": "28a7",
	"./CanadaDay2023Sponsorship.pdf": "cc54",
	"./CanadaDay2023Volunteer.doc": "78f0",
	"./CanadaDay2024Flyer.jpg": "bdcc",
	"./CanadaDay2024Sponsorship.pdf": "acf3",
	"./CanadaDay2025Flyer.pdf": "626ab",
	"./CanadaDay2025Sponsorship.pdf": "6228",
	"./CanadaDay2025Volunteer.pdf.pdf": "45b5",
	"./CanadaDay2026Flyer.pdf": "56fa",
	"./CanadaDay2026Sponsorship.pdf": "073e",
	"./CanadaDay2026Volunteer.pdf": "0158",
	"./back.jpg": "11aa",
	"./favicon.ico": "6e9c",
	"./fireworks-back-blur.jpg": "884e",
	"./gallery-2019/1.jpg": "6a41",
	"./gallery-2019/10.jpg": "2f6a",
	"./gallery-2019/11.jpg": "2d9d",
	"./gallery-2019/12.jpg": "a9ff",
	"./gallery-2019/13.jpg": "a70d",
	"./gallery-2019/14.jpg": "d3bf",
	"./gallery-2019/15.jpg": "8d32",
	"./gallery-2019/16.jpg": "43ec",
	"./gallery-2019/17.jpg": "28fa",
	"./gallery-2019/18.jpg": "fd45",
	"./gallery-2019/19.jpg": "c86b",
	"./gallery-2019/2.jpg": "6e12",
	"./gallery-2019/20.jpg": "b25e",
	"./gallery-2019/21.jpg": "cb07",
	"./gallery-2019/22.jpg": "ba86",
	"./gallery-2019/23.jpg": "6a94",
	"./gallery-2019/24.jpg": "70fd",
	"./gallery-2019/25.jpg": "7214",
	"./gallery-2019/26.jpg": "98b6",
	"./gallery-2019/27.jpg": "37fe",
	"./gallery-2019/28.jpg": "8a21",
	"./gallery-2019/29.jpg": "f105",
	"./gallery-2019/3.jpg": "cccf",
	"./gallery-2019/4.jpg": "fee6",
	"./gallery-2019/5.jpg": "b0a3",
	"./gallery-2019/6.jpg": "9036",
	"./gallery-2019/7.jpg": "9a92",
	"./gallery-2019/8.jpg": "181f",
	"./gallery-2019/9.jpg": "0b4a",
	"./gallery/gallery-image-10.jpg": "6c30",
	"./gallery/gallery-image-12.jpg": "bd4d",
	"./gallery/gallery-image-14.jpg": "52ee",
	"./gallery/gallery-image-16.jpg": "9a05",
	"./gallery/gallery-image-18.jpg": "f3a2",
	"./gallery/gallery-image-2.jpg": "8c47",
	"./gallery/gallery-image-20.jpg": "09fb",
	"./gallery/gallery-image-22.jpg": "ef8d",
	"./gallery/gallery-image-24.jpg": "6ede",
	"./gallery/gallery-image-26.jpg": "16ea",
	"./gallery/gallery-image-27.jpg": "1c45",
	"./gallery/gallery-image-28.jpg": "39f6",
	"./gallery/gallery-image-30.jpg": "42b1",
	"./gallery/gallery-image-32.jpg": "a524",
	"./gallery/gallery-image-34.jpg": "2f0b",
	"./gallery/gallery-image-36.jpg": "b8a3",
	"./gallery/gallery-image-38.jpg": "5f8f",
	"./gallery/gallery-image-4.jpg": "7bb0",
	"./gallery/gallery-image-6.jpg": "91e0",
	"./gallery/gallery-image-8.jpg": "9ea0",
	"./gold/AuburnDev-Logo-Black.png": "b794",
	"./gold/Drewlo.png": "6c03",
	"./gold/FB1211 metro logo cmyk.jpg": "fd93",
	"./gold/Frey.jpg": "7ff8",
	"./gold/LoveSprouts Logo (1).jpg": "a544",
	"./gold/Start.ca_Logo.png": "b21a",
	"./gold/bdo.png": "f6dc",
	"./gold/becklogo2F.jpg": "87ad",
	"./gold/chris-ewer.png": "496a",
	"./gold/church-in-the-oaks.svg": "d58f",
	"./gold/food-basics.svg": "8ab5",
	"./gold/ifast.png": "97ce",
	"./gold/new-era.jpg": "faef",
	"./gold/no-frills.svg": "8ae9",
	"./gold/pa-shop.png": "9825",
	"./gold/select-path.jpg": "7ed5",
	"./gold/tshirttime.png": "18c1",
	"./library.jpg": "12ae",
	"./logo.png": "cf05",
	"./new/Just Fresh.jpeg": "d9eb",
	"./new/auburn-group.png": "5b97",
	"./new/chop-logo.png": "422c",
	"./new/excalibur.jpg": "6362",
	"./new/josh-morgan.png": "8795",
	"./new/lindsay-mathyssen.png": "522a",
	"./new/mr-singhs-pizza.png": "9945",
	"./new/pa-shop.png": "a0cb",
	"./new/sutherland-elliot.jpg": "c65f",
	"./party-bags.png": "3a66",
	"./pattern.png": "e3b3",
	"./platinum/CCWO.jpg": "e036",
	"./platinum/CITYcmyk.jpg": "2d9f",
	"./platinum/Canada150_Logo_MainPrincipal_RedRouge_RGB.png": "84f2e",
	"./platinum/GOODLIFE FITNESS COED.png": "65c7",
	"./platinum/Italian House.jpg": "f29e",
	"./platinum/ON150 Logo (Black).jpg": "8ed0",
	"./platinum/SLNRC logo.jpg": "b21c",
	"./platinum/capc.png": "c38e",
	"./platinum/cv.svg": "3831",
	"./platinum/desjardin.png": "1d3c",
	"./platinum/herritage.png": "c75b",
	"./platinum/logo_york_home.png": "8533",
	"./platinum/macs.png": "9cf5",
	"./platinum/ontario-150.svg": "3a61",
	"./platinum/optimist.svg": "c392",
	"./platinum/our-london.svg": "3929",
	"./platinum/raycullen.jpg": "c384",
	"./platinum/td.png": "017d",
	"./platinum/wom.png": "4fa5",
	"./platinum/zomaron-logo.svg": "318b",
	"./silver/Access Storage Logo.png": "f12a",
	"./silver/Aldus.svg": "c5e7",
	"./silver/BusinessCardAD (1).png": "64db",
	"./silver/Mayor Josh Morgan Graphic.png": "adb5",
	"./silver/StoreNSaveLogo.png": "a9fa",
	"./silver/backdrafts.png": "2cd6",
	"./silver/elizabeth-peloza.png": "9b54",
	"./silver/ifast.jpg": "33b8",
	"./silver/libro.svg": "58ab",
	"./silver/no-frills.png": "01bd",
	"./silver/seifs.svg": "d45d",
	"./silver/teresa-armstrong.png": "f63a",
	"./sponsors/WhiteOaksLogoBlack.jpg": "f34c",
	"./sponsors/auburn-group.jpg": "498d",
	"./sponsors/excalibur.png": "8a55",
	"./sponsors/funvilla.png": "d1b6",
	"./sponsors/golden-hunter-black.jpg": "a618",
	"./sponsors/golden-hunter.jpg": "ca10",
	"./sponsors/ips.jpg": "10ab",
	"./sponsors/josh-morgan.png": "9be2",
	"./sponsors/kurt-holman.png": "4840",
	"./sponsors/rudy.png": "d0d0",
	"./sponsors/zubicks.jpg": "cd4f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";